import MercurioImg from '../images/Mercurio.png';
import VenusImg from '../images/Venus.png';
import TerraImg from '../images/Terra.png';
import MarteImg from '../images/Marte.png';
import JupiterImg from '../images/Jupiter.png';
import SaturnoImg from '../images/Saturno.png';
import Uranoimg from '../images/Urano.png';
import Netunoimg from '../images/Netuno.png';

const Planets = [
  { name: 'Mercúrio', image: MercurioImg },
  { name: 'Vênus', image: VenusImg },
  { name: 'Terra', image: TerraImg },
  { name: 'Marte', image: MarteImg },
  { name: 'Júpiter', image: JupiterImg },
  { name: 'Saturno', image: SaturnoImg },
  { name: 'Urano', image: Uranoimg },
  { name: 'Netuno', image: Netunoimg },
];

export default Planets;
